/* eslint-disable eqeqeq */
/* eslint-disable complexity */
import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import rightArrow from "./images/up-right-arrow.svg";
import mapPinFill from "./images/map-pin-orange.svg";
import mapPin from "./images/map-pin.svg";
import cityImage from "./images/city-bg.png";
import backArrow from "./images/back-arrow.svg";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import {Label} from "@cars24/turbo-web/lib/label";
import { BodyText } from "@cars24/turbo-web/lib/body-text";
import { TinyText } from "@cars24/turbo-web/lib/tiny-text";
import {Button} from "@cars24/turbo-web/lib/button";
import SuffixIcon from "./suffix-icon";

const CityGroupSelector = ({
    onCityClick,
    selectedGroupCityData,
    fetchCityByCityIdConnect,
    isUsedCarRoute,
    onBackClick
}) => {

    const { tokens } = useTokens();
    const { city_name: cityName, inventory_count: groupCityInventoryCount, groupCities, bottom_section_data: bottomSectionData = {}} = selectedGroupCityData || {};
    const {title, sub_title: subTitle, media} = bottomSectionData || {};
    const {DESKTOP: desktopData} = media || {};
    const { url: cityBgImage } = desktopData || {};

    const onCityItemClick = async (e, cityId) => {
        const cityData = await fetchCityByCityIdConnect({cityId});
        onCityClick(e, cityData);
    };

    return (
        <React.Fragment>
            <div styleName={"styles.outer"}>

                <div styleName={"styles.backButton"} onClick={onBackClick}>
                    <span styleName={"styles.cursorPointer"}><img src={backArrow} alt="back" /></span>
                    <Label level={4} color={tokens.text_default_text_primary} fontWeight="semibold" >{cityName || ""}</Label>
                </div>

                <div styleName={"styles.cityWrap styles.flexWrap"}>
                    <div styleName={"styles.flexWrap styles.cursorPointer"} onClick={(e) => onCityClick(e, selectedGroupCityData) }>
                        <div styleName={"styles.flexItem"}>
                            <img width={20} height={20} src={mapPinFill} alt="City" />

                            <Label level={3} fontWeight="medium">{`All cities in ${cityName}`}</Label>
                            {isUsedCarRoute && groupCityInventoryCount && groupCityInventoryCount != 0 ? <BodyText level={2} color={tokens.text_default_text_tertiary}>{`(${groupCityInventoryCount})`}</BodyText> : null}
                        </div>

                        <img width={24} height={24} src={rightArrow} alt="City" />
                    </div>

                    <ul className={"mb-0"} styleName={"styles.cityList"}>
                        {
                            (groupCities || []).map((item, index) => (

                                <li styleName={"styles.flexWrap"} key={index} onClick={(e) => onCityItemClick(e, item.cityId)}>
                                    <div styleName={"styles.flexItem"}>
                                        <img width={20} height={20} src={mapPin} alt="City" />

                                        <Label level={3} fontWeight="medium">{item?.cityName || ""}</Label>
                                        {isUsedCarRoute && item?.inventory_count ? <BodyText level={2} color={tokens.text_default_text_tertiary}>{`(${item?.inventory_count})`}</BodyText> : null}
                                    </div>

                                    <img width={24} height={24} src={rightArrow} alt="City" />
                                </li>
                            ))
                        }
                    </ul>
                </div>
            </div>

            {bottomSectionData && isUsedCarRoute ? <div styleName={"styles.ncrCity"} style={{background: `url("${cityBgImage || cityImage}") no-repeat`}}>
                <div styleName={"styles.ncrCityContent"}>
                    <TinyText isBold upperCase>{title}</TinyText>
                    <Label level={3} fontWeight="medium">{subTitle}</Label>

                    <Button
                        label="View cars"
                        onClick={(e) => onCityClick(e, selectedGroupCityData)}
                        size="medium"
                        variant="tertiary"
                        suffixIcon={<SuffixIcon/>}
                    />
                </div>
            </div> : null}
        </React.Fragment>
    );
};

CityGroupSelector.propTypes = {
    onCityClick: PropTypes.func,
    selectedGroupCityData: PropTypes.object,
    fetchCityByCityIdConnect: PropTypes.func,
    isUsedCarRoute: PropTypes.bool,
    onBackClick: PropTypes.func
};

export default CityGroupSelector;
